import CommonHeader from '../pages/Head'
import React from 'react'
import {Link} from "react-router-dom";
import axios from 'axios';
import ApplyImg from '../images/Apply Now_1.jpg'
import ExistCustomer from '../images/Existing_Customers.jpg'
import CanMoney from '../images/payday-payday-loans-ca-4.jpg'

class HomtContents extends React.Component {	  
	constructor(props) {
		super(props);
		this.state = {CompName:''};				
	}

	componentDidMount() {				
		axios.post(process.env.REACT_APP_API_ENV+'api/FindCompanyName.php')
			.then(result => {				
				this.setState({CompName:result.data[0]})													
			})		
	}
	render() {		
		return(
			<div>
				<CommonHeader titles="Payday Loan Privacy"/>				
				<h1 className="headings" style={{textAlign:"center",color:"green"}}><small>{this.state.CompName}--Payday Loan Provider for Canadians</small></h1>				
				<div id="contentwrapper" >
					<div id="contentcolumn">
						<Link className="applybutton" to = "/Apply"><img border="0" src={ApplyImg} alt="Payday loans application"/></Link>
						<Link className="applybutton" to = "/Member"><img border="0" src={ExistCustomer} alt="Payday loans Returning Customers"/></Link>
					</div>
				</div>
				<div id="rightcolumn">
					<div className="innertext">
						<b style={{color:"green"}}>No Fax</b><br/>
						<b style={{color:"green"}}>Fast and Easy</b><br/>
						<b style={{color:"green"}}>No hidden cost</b><br/>
						<b style={{color:"green"}}>No Credit Check</b><br/>
						<b style={{color:"green"}}>Up to $600 until next pay day</b><br/>
						<b style={{color:"green"}}>Cash advance deposited directly to your account</b><br/>
					</div>
				</div>
				<div id="leftcolumn" title="Your payday loans"><img src={CanMoney} alt="Your Payday loans and cash advance"/></div>
				<div id="bottom"><br/>
					<h1 style={{color:"blue"}}>Policy of Privacy</h1>				

					<h4 style={{color:"grey"}}>{this.state.CompName} respects your right to privacy and adheres to the following privacy principles to handle all your personally identifiable information carefully and strictly:</h4>

					<h4 style={{color:"grey"}}>1. We collect information to provide better services to our customers. The collection of personal information is limited to that is related to your payday loan/cash advance purposes identified by {this.state.CompName}.</h4>

					<h4 style={{color:"grey"}}>2. We use the information we collect from our customers to offer tailored service to our customers and  the information is under the strict control by our designated individuals for the company's compliance.</h4>

					<h4 style={{color:"grey"}}>3. We identify the purpose of the personal information and communiate it at or before the information is collected</h4>
					 
					<h4 style={{color:"grey"}}>4. We will obtain the consent and knowledge before we collect the personal information for the use and disclosure<br/><br/>
					When you apply to open an account at {this.state.CompName}, all the personal information you are asked to provide us will be stored on limited access servers and is dealt with strictly in accordance with this policy</h4>

					<h4 style={{color:"grey"}}>5. We will not use or disclose the personal and confidential information for other purposes unrelated to the payday loan and cash advance without the consent of the customer, except required by law.</h4>

					<h4 style={{color:"grey"}}>6. We will make effort to ensure the accurate and complete personal information for the payday loan and cash advance purposes, we will amend where appropriate by the address of our customers and this will depend on our customers to provide us the correct and necessary informaton</h4>

					<h4 style={{color:"grey"}}>7. We regularly review our compliance with our Privacy Policy. we strictly maintain and implement procedures to protect the personal information.</h4>

					<h4 style={{color:"grey"}}>8. we will comply fully with all laws and regulations applicable with our privacy policy. </h4>

					<h4 style={{color:"grey"}}>{this.state.CompName} is not responsible for the privacy practices of websites that are linked from our website. Please consult the privacy policy for the website you link to from {this.state.CompName}</h4> 
					
					
				</div>								
			</div>
		)
	}
}

export default HomtContents